var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{ref:"logoutModal",attrs:{"title":"Ready to Leave?","cancel-variant":"link-gray","ok-title":"Logout"},on:{"ok":_vm.onOk}},[_c('p',{staticClass:"my-4"},[_vm._v("Click \"Logout\" if you are ready to end your current session.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }